"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntryStatusEnum = void 0;
var EntryStatusEnum;
(function (EntryStatusEnum) {
    EntryStatusEnum["ALTERNATE"] = "ALTERNATE";
    EntryStatusEnum["CONFIRMED"] = "CONFIRMED";
    EntryStatusEnum["DIRECT_ACCEPTANCE"] = "DIRECT_ACCEPTANCE";
    EntryStatusEnum["FEED_IN"] = "FEED_IN";
    EntryStatusEnum["JUNIOR_EXEMPT"] = "JUNIOR_EXEMPT";
    EntryStatusEnum["LUCKY_LOSER"] = "LUCKY_LOSER";
    EntryStatusEnum["ORGANISER_ACCEPTANCE"] = "ORGANISER_ACCEPTANCE";
    EntryStatusEnum["QUALIFIER"] = "QUALIFIER";
    EntryStatusEnum["REGISTERED"] = "REGISTERED";
    EntryStatusEnum["SPECIAL_EXEMPT"] = "SPECIAL_EXEMPT";
    EntryStatusEnum["WILDCARD"] = "WILDCARD";
    EntryStatusEnum["WITHDRAWN"] = "WITHDRAWN";
    EntryStatusEnum["UNPAIRED"] = "UNPAIRED";
    EntryStatusEnum["UNGROUPED"] = "UNGROUPED"; // replacing UNPAIRED as a more generic term also applicable to { participantType: TEAM }
})(EntryStatusEnum || (exports.EntryStatusEnum = EntryStatusEnum = {}));
//# sourceMappingURL=entry_status.js.map